import React from 'react';
import ResponsiveWrapper from '../../../components/ResponsiveWrapper';
import SystemLog from './index';
import MobileSystemLog from './MobileSystemLog';

const ResponsiveSystemLog = () => {
  return (
    <ResponsiveWrapper
      mobile={<MobileSystemLog />}
      desktop={<SystemLog />}
    />
  );
};

export default ResponsiveSystemLog;
